import * as $ from "jquery";
import * as userMessaging from "./svc-user-messaging";
import { TokenManager } from '../auth/token-manager';

export function GetDataRequestService(): IDataRequestService {
    return new DataRequestService();
}

export interface IRequestSent {
    (): void;
}

export interface IDataRequestService {
    SendJsonRequest(type: string, url: string, success, error): void;
    SendJsonRequestWithData(type: string, url: string, data, success, error, async): void;
    SendJsonRequestWithDataVerbose(type: string, url: string, data, success, error, withCredentials, async: boolean): void;
    sendJsonRequestForFile(url: string, data, fileExt: string, success, error): void;
}

export var OnRequestSent: IRequestSent;

export function SetOnRequestSent(requestSent: IRequestSent): void {
    OnRequestSent = requestSent;
}

class DataRequestService implements IDataRequestService {
    private tokenManager = TokenManager.getInstance();

    private showMessage(message: string, messageType: userMessaging.MessageTypeOption): void {
        const service = userMessaging.GetUserMessagingService();
        service.SendMessage(new userMessaging.UserMessage(message, messageType));
    }

    private async handleTokenRefresh(): Promise<string | null> {
        return await this.tokenManager.refreshAccessToken();
    }

    public SendJsonRequest(type, url, success, error): void {
        this.SendJsonRequestWithData(type, url, null, success, error, false);
    }

    public SendJsonRequestWithData(
        type,
        url,
        data,
        success,
        error,
        async
    ): void {
        this.SendJsonRequestWithDataVerbose(type, url, data, success, error, true, async);
    }

    public SendJsonRequestWithDataVerbose(
        type,
        url,
        data,
        success,
        error,
        withCredentials,
        async
    ): void {
 
        // Convert data to JSON if it's not null
        const dataToSend = data ? type.toUpperCase() === 'GET' ? data : JSON.stringify(data) : null;

        // Make the AJAX request with the updated token
        this.makeAjaxRequest(type, url, dataToSend, success, error, async, null, withCredentials);
    }  

    public sendJsonRequestForFile(url, data, fileExt, success, error) {
        this.makeAjaxRequest('POST', url, JSON.stringify(data), success, error, true, fileExt);
    }

    private makeAjaxRequest(type, url, dataToSend, success, error, async, fileExt, withCredentials = true, isRetry = false) {
        const sendRequest = () => {
            console.log('** API Call:', url, 'on page:', window.location.pathname);

            const token = this.tokenManager.getToken();
            const headers: any = {
                'Content-Type': 'application/json'
            };
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }
            console.log('sending ' + url);

            $.ajax({
                method: type,
                url: process.env.REACT_APP_API_URL.concat(url),
                //headers: {
                // PROBLEM: Sends "Bearer " (with empty token) when no token exists, which may bypass some server-side checks.
                //    Authorization: 'Bearer ' + (token === null ? '' : token)
                //},
                headers: headers,
                xhrFields: setResponseTypeForXhr(withCredentials),
                async: async,
                data: dataToSend,
                contentType: 'application/json',
                success: success,
                error: async (jqXHR, textStatus, errorThrown) => {
                    let hasError: boolean = false;
                    // handle 401 response  and try to refresh the token
                    //if (jqXHR.status === 401 && !isRetry) {
                    //    console.log('401 received, attempting token refresh...');

                    //    const newToken = await this.handleTokenRefresh();

                    //    if (newToken) {
                    //        console.log('Token refreshed successfully, retrying request...');
                    //        // Retry the original request with new token
                    //        this.makeAjaxRequest(
                    //            type,
                    //            url,
                    //            dataToSend,
                    //            success,
                    //            error,
                    //            async,
                    //            fileExt,
                    //            withCredentials,
                    //            true // Mark as retry to prevent infinite loop
                    //        );
                    //        return; // Exit early, don't process error
                    //    } else if (jqXHR.status === 401 && isRetry) {
                    //        // Token refresh was attempted but still getting 401
                    //        console.log('Still 401 after refresh, redirecting to logged out page...');
                    //        this.tokenManager.clearToken();
                    //        //window.location.href = '/logged-out';
                    //        return;
                    //    } else {
                    //        console.log('Token refresh failed, redirecting to logged out page...');
                    //        // Refresh failed - redirect to logged out
                    //        this.tokenManager.clearToken();
                    //        //window.location.href = '/logged-out';
                    //        return;
                    //    }
                    //}
                    if (jqXHR.status === 401) {
                        if (!isRetry) {
                            console.log('401 received, attempting token refresh...');
                            const newToken = await this.handleTokenRefresh();

                            if (newToken) {
                                console.log('Token refreshed successfully, retrying request...');
                                this.makeAjaxRequest(
                                    type, url, dataToSend, success, error,
                                    async, fileExt, withCredentials, true
                                );
                                return;
                            } else {
                                // Refresh failed - logout
                                console.log('Token refresh failed, redirecting to logged out...');
                                this.tokenManager.clearToken();
                                window.location.href = '/logged-out';
                                return;
                            } 
                        } else {
                            // Retry also got 401 - this shouldn't happen
                            console.error('Retry request got 401 - this indicates a problem');
                            console.error('URL:', url);
                            console.error('Token:', this.tokenManager.getToken()?.substring(0, 20));

                            // Don't immediately logout - log the error
                            if (error) error(jqXHR);
                            return;
                        }

                        // Either refresh failed or this was already a retry
                        //console.log('Authentication failed, redirecting to logged out...');
                        //this.tokenManager.clearToken();
                        //window.location.href = '/logged-out';
                        //return;
                    }
                    else if (jqXHR.status === 403) {
                        // Authorization failure - user lacks permission
                        //if (jqXHR.responseText) {
                        //    this.showMessage(jqXHR.responseText, userMessaging.MessageTypeOption.Error);
                        //} else {
                        //    this.showMessage("You do not have permission to access this resource", userMessaging.MessageTypeOption.Error);
                        //}
                        //if (error) error(jqXHR);
                        const message = jqXHR.responseText || "You do not have permission to access this resource";
                        this.showMessage(message, userMessaging.MessageTypeOption.Error);
                        if (error) error(jqXHR);
                        return;
                    } else if (jqXHR.status === 400) { 
                        if (jqXHR.responseJSON) {
                            const msg = this.formatValidationErrors(jqXHR.responseJSON);
                            if (msg)
                                this.showMessage(msg, userMessaging.MessageTypeOption.Error);
                            else
                                this.showMessage('Bad request', userMessaging.MessageTypeOption.Error);
                        } else {
                            this.showMessage(jqXHR.responseText, userMessaging.MessageTypeOption.Error);
                        }                        
                    } else if (jqXHR.status === 500) {
                        this.showMessage('There was a problem with your request. If you continue to see this message, please contact the Help Desk.', userMessaging.MessageTypeOption.Error);
                        if (jqXHR.responseText) {
                            console.log(jqXHR.responseText);
                        }
                    } else {
                        // handle other errors
                        const allHeaders = jqXHR.getAllResponseHeaders();
                        const headersMap = {};
                        try {
                            // Parse headers
                            const headersArray = allHeaders.trim().split(/[\r\n]+/);
                            headersArray.forEach(function(line) {
                                const parts = line.split(': ');
                                const header = parts.shift();
                                const value = parts.join(': ');
                                headersMap[header.toLowerCase()] = value; // Normalize header names to lowercase
                            });
                        } catch (error) {
                            console.error('Error parsing headers:', error);                           
                        }

                        // Check for the custom error message header
                        const errorMessage = headersMap['x-error-message'];
                        if (errorMessage) {
                            this.showMessage(errorMessage, userMessaging.MessageTypeOption.Error);
                        }
                        else if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
                            this.showMessage(jqXHR.responseJSON.message, userMessaging.MessageTypeOption.Error);
                        } else {
                            this.showMessage("An error occurred trying to request information: " + textStatus, userMessaging.MessageTypeOption.Error);
                        }
                        hasError = true;
                    }
                    if (hasError && error) {
                        error(jqXHR);
                    }
                }
            });

            function setResponseTypeForXhr(withCredentials): JQuery.Ajax.XHRFields {                
                // If fileExt is empty, return empty object
                if (fileExt === null || fileExt === '' || fileExt === undefined) {
                    return { withCredentials };
                }

                // For HTML files, responseType should be 'text'
                if(fileExt.toLowerCase() === '.html') {
                    return {
                        responseType: 'text',
                        withCredentials
                    };
                }
                
                // For all other files, responseType should be 'blob'
                return {
                    responseType: 'blob',
                    withCredentials
                };
            }
        }

        sendRequest();
    }

    private formatValidationErrors(response: any): string {
        if (!response.errors || typeof response.errors !== "object") return "";

        // Extract the errors and format them
        const errorMessages = Object.entries(response.errors).map(
            ([key, value]) => `${key}: ${Array.isArray(value) ? value.join(", ") : value}`
        );

        // Join all the error messages with commas
        return errorMessages.join(", ");
    }

    //public sendJsonRequestForFile(data, url, nameOfFile) {
    //    const tokens = this.tokenRepository.getToken();
    //    const xhr = new XMLHttpRequest();
    //    xhr.open('POST', process.env.REACT_APP_API_URL.concat(url), true);
    //    xhr.setRequestHeader('Authorization', 'Bearer ' + (tokens === null ? '' : tokens.accessToken));
    //    xhr.responseType = 'arraybuffer';
    //    xhr.setRequestHeader('Content-Type', 'application/json');

    //    xhr.onload = function () {
    //        if (xhr.status === 200) {
    //            const data = xhr.response;
    //            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //            const link = document.createElement('a');
    //            link.href = window.URL.createObjectURL(blob);
    //            link.download = nameOfFile;
    //            document.body.appendChild(link);
    //            link.click();
    //            document.body.removeChild(link);
    //        } else if (xhr.status === 401) {

    //        } else {
    //            console.error('AJAX error:', xhr.statusText);
    //        }
    //    };

    //    xhr.onerror = function () {
    //        console.error('A network error occurred');
    //    };

    //    xhr.send(JSON.stringify(data));
    //}
}
